<mat-card class="mat-elevation-z">

  <button mat-fab *ngIf="content.button_icon"><mat-icon>{{content.button_icon}}</mat-icon></button>

  <ng-template #header>
    <mat-card-header>
      <mat-card-title>{{content.title}}</mat-card-title>
      <mat-card-subtitle>{{content.subtitle}}</mat-card-subtitle>
    </mat-card-header>
  </ng-template>

  <mat-card-title *ngIf="content.subtitle===undefined; else header">{{content.title}}</mat-card-title>

  <mat-card-content>

    <mat-divider *ngIf="content.image_source===undefined" [inset]="true"></mat-divider>

    <img class="mat-elevation-z4" *ngIf="content.image_source" [src]="content.image_source">


    <div *ngIf="content.sections" class="container">
      <div class="section" *ngFor="let section of content.sections" [innerHTML]="section"></div>
    </div>

  </mat-card-content>

</mat-card>

